







































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { GetTools, GetToolUrl } from '../../api/common/index';
import { getObsToken } from '../../api/common/index';

@Component({
  components: {},
})
export default class Index extends Vue {
  mounted() {
    this.getTools();
  }
  toolList = [];
  workList = [];
  async getTools() {
    GetTools({ isIndex: false }).then(res => {
      this.toolList = res.subToolClassifyList[0].subToolClassifyList;
      this.workList = res.subToolClassifyList[1].subToolClassifyList;
    });
  }

  handleWorkNav(item: any) {
    if (item.isOuterUrl) {
      window.open(item.url, '_blank');
    } else {
      this.$router.push(item.url);
    }
  }

  dialogVerify = false;
  toolCode = '';
  toolVerify = '';

  handleToolNav(item: any) {
    if (item.isOuterUrl) {
      GetToolUrl({ toolCode: item.code, verify: '' }).then(res => {
        if (res.code == 0) {
          window.open(res.url, '_blank');
        } else if (res.code == 900061) {
          this.toolCode = item.code;
          this.dialogVerify = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    } else {
      this.$router.push(item.url);
    }
  }

  confirmToolNav() {
    if (!this.toolVerify) {
      return this.$message.warning('请填写验证码');
    }
    GetToolUrl({ toolCode: this.toolCode, verify: this.toolVerify }).then(res => {
      if (res.code == 0) {
        this.dialogVerify = false;
        window.open(res.url, '_blank');
      } else {
        this.$message.error(res.msg);
      }
    });
  }

  closeDialog() {
    this.dialogVerify = false;
  }
}
